import { Restore, Check } from "@mui/icons-material";
import { Button, Tab, Tabs, TextField, Typography } from "@mui/material";
import { useState } from "react";
import { ReactGrid } from "@silevis/reactgrid";
import "@silevis/reactgrid/styles.css";

const headerRow = {
  rowId: "header",
  cells: [
    { type: "header", text: "Measured Depth (m)" },
    { type: "header", text: "Inclination (deg)" },
    { type: "header", text: "Azimuth" },
    { type: "header", text: "TVD (m)" }
  ]
};

const getColumns = () => [
  { columnId: "measuredDepth", width: 150 },
  { columnId: "inclination", width: 150 },
  { columnId: "azimuth", width: 150 },
  { columnId: "trueVerticalDepth", width: 150 }
];

export const RTFOPadMonitorSurveys = ({ monitorIds, monitorSurveys, setMonitorSurveys }) => {
  
  const [tabItem, setTabItem] = useState(0);
  const [isModified, setIsModified] = useState(true);

  let sortedMonitorIds = monitorIds?.length > 0 ? [...monitorIds?.split(',')?.map(el => el?.trim())] : [];
  sortedMonitorIds = sortedMonitorIds.sort((a, b) => a - b);
  const monitorName = sortedMonitorIds?.[tabItem];

  const [data, setData] = useState(() => {
    const rows = [];

    for (let i = 0; i < 1000; i++) {
      rows.push({
        measuredDepth: monitorSurveys?.[monitorName]?.surveyData?.[i]?.measuredDepth >= 0 ? monitorSurveys?.[monitorName]?.surveyData?.[i]?.measuredDepth : null,
        inclination: monitorSurveys?.[monitorName]?.surveyData?.[i]?.deviation >= 0 ? monitorSurveys?.[monitorName]?.surveyData?.[i]?.deviation : null,
        azimuth: monitorSurveys?.[monitorName]?.surveyData?.[i]?.direction >= 0 ? monitorSurveys?.[monitorName]?.surveyData?.[i]?.direction : null,
        trueVerticalDepth: monitorSurveys?.[monitorName]?.surveyData?.[i]?.trueVerticalDepth >= 0 ? monitorSurveys?.[monitorName]?.surveyData?.[i]?.trueVerticalDepth : null
      });
    };

    return rows;
  });

  const getRows = (data) => [
    headerRow,
    ...data.map((row, idx) => ({
      rowId: idx,
      cells: [
        { type: "number", value: row.measuredDepth },
        { type: "number", value: row.inclination },
        { type: "number", value: row.azimuth },
        { type: "number", value: row.trueVerticalDepth }
      ]
    }))
  ];

  const rows = getRows(data);
  const columns = getColumns();

  const applyChangesToData = (changes, prevData) => {
    changes.forEach((change) => {
      const dataIndex = change.rowId;
      const fieldName = change.columnId;
      prevData[dataIndex][fieldName] = change.newCell.value;
    });
    return [...prevData];
  };

  const handleChanges = (changes) => { 
    setData((prevData) => applyChangesToData(changes, prevData));
    setIsModified(true);
  }; 

  try {
    return (
      <div style={{display: 'flex', flexDirection: 'column', width: '100%', height: '100%', position: 'relative', overflow: 'hidden'}}>
        <div>
          <Tabs
            value={tabItem}
            onChange={(e, value) => handleTabChange(value)}
            style={{borderBottom: '1px solid lightgrey', marginBottom: 20}}
          >
            {sortedMonitorIds?.map(monitor => {
              return (<Tab label={monitor} key={monitor} />)
            })}
          </Tabs>
          
          <div style={{marginBottom: 20}}>
            <Button variant="contained" size="small" startIcon={<Check />} onClick={handleSaveClick} style={{marginRight: 20}} disabled={!isModified}>Save Survey</Button>
            <Button variant="outlined" size="small" startIcon={<Restore />} onClick={handleResetClick}>Reset</Button>
          </div>
          
          <div style={{display: 'flex', flexDirection: 'row', marginBottom: 10}}>
            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '15%', marginRight: 10}}>
              <Typography fontSize="14px">Surface Latitude</Typography>
              <TextField
                margin="dense"
                size="small"
                value={monitorSurveys[monitorName]?.surfaceLat || 0}
                placeholder="Surface Latitude"
                variant="outlined"
                fullWidth
                InputProps={{ style: { fontSize: 14 }}}
                onChange={handleSurfaceLatChange}
              />
            </div>
            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '15%', marginRight: 10}}>
              <Typography fontSize="14px">Surface Longitude</Typography>
              <TextField
                margin="dense"
                size="small"
                value={monitorSurveys[monitorName]?.surfaceLon || 0}
                placeholder="Surface Longitude"
                variant="outlined"
                fullWidth
                InputProps={{ style: { fontSize: 14 }}}
                onChange={handleSurfaceLonChange}
              />
            </div>
          </div>
        </div>
        <div style={{maxHeight: 900, overflow: 'scroll'}}>
          <ReactGrid 
            rows={rows} 
            columns={columns} 
            onCellsChanged={handleChanges} 
            enableRangeSelection 
            enableFillHandle 
            stickyTopRows={1}
          />
        </div>
      </div>
    );
  } catch (error) {
    console.log(error);
    return <></>;
  };

  function handleTabChange(newTabItem) {
    try {
      if (newTabItem >= 0) {
        setTabItem(newTabItem)
        
        const monitorName = sortedMonitorIds[newTabItem];
        const rows = [];

        for (let i = 0; i < 1000; i++) {
          rows.push({
            measuredDepth: monitorSurveys?.[monitorName]?.surveyData?.[i]?.measuredDepth >= 0 ? monitorSurveys?.[monitorName]?.surveyData?.[i]?.measuredDepth : null,
            inclination: monitorSurveys?.[monitorName]?.surveyData?.[i]?.deviation >= 0 ? monitorSurveys?.[monitorName]?.surveyData?.[i]?.deviation : null,
            azimuth: monitorSurveys?.[monitorName]?.surveyData?.[i]?.direction >= 0 ? monitorSurveys?.[monitorName]?.surveyData?.[i]?.direction : null,
            trueVerticalDepth: monitorSurveys?.[monitorName]?.surveyData?.[i]?.trueVerticalDepth >= 0 ? monitorSurveys?.[monitorName]?.surveyData?.[i]?.trueVerticalDepth : null
          });
        };

        setData(() => rows);
        setIsModified(false);
      };

    } catch (error) {
      console.log(error);
      return;
    };
  };

  function handleSaveClick() {
    try {
      const wellSurvey = [];
  
      for (let i = 0; i < data?.length; i++) {
        const row = data[i];
  
        if (Number(row?.measuredDepth) > 0) {
          wellSurvey.push({
            measuredDepth: Number(row?.measuredDepth) >= 0 ? Number(row?.measuredDepth) : null,
            deviation: Number(row?.inclination) >= 0 ? Number(row?.inclination) : null,
            direction: Number(row?.azimuth) >= 0 ? Number(row?.azimuth) : null,
            trueVerticalDepth: Number(row?.trueVerticalDepth) >= 0 ? Number(row?.trueVerticalDepth) : null
          });
        };
      };
  
      const newSurveys = JSON.parse(JSON.stringify(monitorSurveys));
      newSurveys[monitorName].surveyData = wellSurvey;
      setMonitorSurveys(() => newSurveys);
  
      setIsModified(false);

    } catch (error) {
      console.log(error);
    };
  };

  function handleResetClick() {
    try {
      const rows = [];
  
      for (let i = 0; i < 1000; i++) {
        rows.push({
          measuredDepth: monitorSurveys?.[monitorName]?.surveyData?.[i]?.measuredDepth >= 0 ? monitorSurveys?.[monitorName]?.surveyData?.[i]?.measuredDepth : null,
          inclination: monitorSurveys?.[monitorName]?.surveyData?.[i]?.deviation >= 0 ? monitorSurveys?.[monitorName]?.surveyData?.[i]?.deviation : null,
          azimuth: monitorSurveys?.[monitorName]?.surveyData?.[i]?.direction >= 0 ? monitorSurveys?.[monitorName]?.surveyData?.[i]?.direction : null,
          trueVerticalDepth: monitorSurveys?.[monitorName]?.surveyData?.[i]?.trueVerticalDepth >= 0 ? monitorSurveys?.[monitorName]?.surveyData?.[i]?.trueVerticalDepth : null
        });
      };
  
      setData(() => rows);
  
      setIsModified(false);

    } catch (error) {
      console.log(error);
      return;
    };
  };

  function handleSurfaceLatChange(e) {
    const newValue = +e.target.value;
    if (isNaN(newValue)) return;

    setMonitorSurveys(prev => ({...prev, [monitorName]: {...prev[monitorName], surfaceLat: newValue}}));
    return;
  };
  function handleSurfaceLonChange(e) {
    const newValue = +e.target.value;
    if (isNaN(newValue)) return;

    setMonitorSurveys(prev => ({...prev, [monitorName]: {...prev[monitorName], surfaceLon: newValue}}));
    return;
  };
};